import type { SideNavItem } from './types';

/** Whether the entry, or one of the links nested under it, is the current page. */
export function isItemActive(item: SideNavItem, activeKey?: string | null) {
  if (activeKey === undefined || activeKey === null) {
    return false;
  }
  return (
    item.key === activeKey ||
    (item.children ?? []).some((child) => child.key === activeKey)
  );
}

export function isLinkCurrent(key: string, activeKey?: string | null) {
  return activeKey !== undefined && activeKey !== null && key === activeKey;
}
